module.exports = __webpack_public_path__ + "img/blockfi-light.459f468e.svg";